import type { AgentRu } from '../i18n';

/** Russian overlays for agent role/task, keyed by agent id. */
export const agentsRu: Record<string, AgentRu> = {
  'r-01': {
    role: 'Исследовательский интеллект',
    task: 'Анализирует направление agent-native ПО',
  },
  'r-02': {
    role: 'Исследовательский интеллект',
    task: 'Изучает литературу по моделям усвоения',
  },
  'r-03': {
    role: 'Исследовательский интеллект',
    task: 'Стресс-тестирует численные граничные случаи',
  },
  'r-04': {
    role: 'Исследовательский интеллект',
    task: 'Формулирует гипотезы о структурном росте',
  },
  'k-01': {
    role: 'Инженерия знаний',
    task: 'Связывает новые узлы в графе лаборатории',
  },
  'k-02': {
    role: 'Инженерия знаний',
    task: 'Отслеживает происхождение импортированного материала',
  },
  'a-01': {
    role: 'Архитектура',
    task: 'Перебалансирует границы сервисов',
  },
  's-01': {
    role: 'Безопасность',
    task: 'Сканирует периметр инфраструктуры',
  },
  's-02': {
    role: 'Безопасность',
    task: 'Проверяет границы публикаций',
  },
  'e-01': {
    role: 'Экспериментирование',
    task: 'Прогоняет сценарии внедрения отказов в консенсус',
  },
  'i-01': {
    role: 'Инфраструктура',
    task: 'Следит за состоянием развёртываний',
  },
  'p-01': {
    role: 'Продукт',
    task: 'Сопоставляет результаты исследований с продуктовыми сигналами',
  },
  'd-01': {
    role: 'Данные',
    task: 'Курирует наборы данных для оценки',
  },
  'v-01': {
    role: 'Научная экспертиза',
    task: 'Проверяет утверждения перед тем, как они покинут лабораторию',
  },
};
